import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

export interface SwapLabelsItemProps {
    recordId: string;
    isDisabled: boolean;
    onClick: () => void;
    onRemove: () => void;
    correctionSelected: boolean;
}

export const SwapLabelsItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected }: SwapLabelsItemProps): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title="Swap Session Labels"
                description="Swap the session labels with an already existing session"
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
